<div class="zn-step-content-sections">
  <div [class]="selectionSectionClass()">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.Selection.Title') | abpLocalization }}</h5>
          <p>{{ (localizationKeyPrefix + '.Selection.Description') | abpLocalization }}</p>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-step-content-section-layout">
        <div class="zn-step-content-section-filters">
          <div class="form-control-container">
            <label class="form-label" for="standDivisionAndFusionFusedStandSelect">
              {{ 'Planning::Entity.Stand' | abpLocalization }}
              <span class="form-label-required">*</span>
            </label>
            <zn-single-select
              #standSelect
              id="standDivisionAndFusionFusedStandSelect"
              [options]="fusedStandOptions()"
              [optionsLoader]="loadFusedStands()"
              [showSearch]="true"
              [localizationResource]="localizationResource"
              [placeholder]="(localizationKeyPrefix + '.Selection.Placeholder') | abpLocalization"
              [openUp]="false"
              (selectedChange)="onStandChange($event)"
            ></zn-single-select>
          </div>
        </div>
        <div class="zn-step-content-section-actions" hidden>
          <zn-button
            type="secondary"
            size="normal"
            iconLeft="bi bi-plus"
            [label]="(localizationKeyPrefix + '.Selection.Create') | abpLocalization"
            (clicked)="createNewStand()"
          ></zn-button>
        </div>
      </div>
    </div>
  </div>

  <div [class]="summarySectionClass()">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.Summary.CreatedTitle') | abpLocalization }}</h5>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-summary">
        <section>
          <div class="zn-summary-grid">
            <div class="zn-summary-item">
              <p class="title">{{ (localizationKeyPrefix + '.Fields.NewStand') | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(fusedStand()?.name) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ 'Geographic::Entity.Cycle' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(fusedStand()?.cycle) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ 'Geographic::Entity.Rotation' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(fusedStand()?.rotation) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ (localizationKeyPrefix + '.Fields.StandArea') | abpLocalization }}</p>
              <p class="subtitle">{{ formatArea(fusedStand()?.currentArea) }}</p>
            </div>
          </div>
        </section>

        <section>
          <h6>{{ (localizationKeyPrefix + '.Summary.AssociationTitle') | abpLocalization }}</h6>
          <div class="zn-summary-grid">
            <div class="zn-summary-item">
              <p class="title">{{ (localizationKeyPrefix + '.Fields.LandContract') | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(fusedStand()?.landContract) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ (localizationKeyPrefix + '.Fields.LandContractType') | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(fusedStand()?.landContractType) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ (localizationKeyPrefix + '.Fields.ForestContract') | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(fusedStand()?.forestContract) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ (localizationKeyPrefix + '.Fields.ForestContractType') | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(fusedStand()?.forestContractType) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ (localizationKeyPrefix + '.Fields.PropertyType') | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(fusedStand()?.propertyType) }}</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>

